import { ReactComponent as TakeReadingIcon } from "assets/svgs/inspections/TakeReading.svg";

export const TakeReadingShowIcons = {
    false: <TakeReadingIcon className="w-6" />,
    true: <TakeReadingIcon className="w-6" />,
};
export const DefaultShowTakeReading = false;
